<template>
  <div class="BottomNav lxn-w100">
    <div class="BottomNav-wrapper-line lxn-w100 lxn-pos-rel">
      <div class="BottomNav-line lxn-h100 lxn-pos-rel" :class="lineNavClass">
      </div>
    </div>
    <div class="BottomNav-wrapper lxn-w100">
      <div class="BottomNav-wrapper-side lxn-h100 lxn-float-left">
        <div @click="goto(0)" :class="isItemSelected(0)" class="BottomNav-wrapper-middle lxn-h100 lxn-margin-auto lxn-pos-rel lxn-cursor-pointer">
          <div v-html="leftSvgIcon" class="BottomNav-svg">
          </div>
          <div :class="$store.getters.language.font" class="BottomNav-text lxn-small-text lxn-w100 lxn-text-center">
            {{$store.getters.language.texts.BottomNav_dashboard}}
          </div>
          <div class="BottomNav-circle lxn-pos-abs">
          </div>
        </div>
      </div>
      <div @click="goto(1)" :class="isItemSelected(1)" class="BottomNav-wrapper-middle lxn-h100 lxn-float-left lxn-pos-rel lxn-cursor-pointer">
        <div v-html="middleSvgIcon" class="BottomNav-svg">
        </div>
        <div :class="$store.getters.language.font" class="BottomNav-text lxn-small-text lxn-w100 lxn-text-center">
          {{$store.getters.language.texts.BottomNav_devices}}
        </div>
        <div class="BottomNav-circle lxn-pos-abs">
        </div>
      </div>
      <div class="BottomNav-wrapper-side lxn-h100 lxn-float-left">
        <div @click="goto(2)" :class="isItemSelected(2)" class="BottomNav-wrapper-middle lxn-h100 lxn-margin-auto lxn-pos-rel lxn-cursor-pointer">
          <div v-html="rightSvgIcon" class="BottomNav-svg">
          </div>
          <div :class="$store.getters.language.font" class="BottomNav-text lxn-small-text lxn-w100 lxn-text-center">
            {{$store.getters.language.texts.BottomNav_settings}}
          </div>
          <div class="BottomNav-circle lxn-pos-abs">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgIcons from '@/statics/svgIcons.js'

export default {
  name: 'BottomNav',
  props: {

  },
  data: function () {
    return {
      leftSvgIcon: svgIcons.dashboard,
      middleSvgIcon: svgIcons.devices,
      rightSvgIcon: svgIcons.cog,
    }
  },
  watch: {
  },
  computed: {
    routerLinks: function () {
      return [
        '/home/dashboard/' + this.activeDashboardFolderId,
        '/home/devices/',
        '/home/settings/',
        '/home/dashboard/' + this.activeDashboardFolderId,
        '/home/devices',
        '/home/settings',
      ]
    },
    activeDashboardFolderId: function () {
      return this.$store.state.activeDashboardFolderId;
    },
     lineNavClass: function() {
       var lineNavClass = 'active0';
       for(var i = 0; i < this.routerLinks.length; i++){
         if(this.routerLinks[i] == this.$route.path.toLowerCase()){
           return 'active' + i%3;
         }
       }
       return lineNavClass;
     }
  },
  methods: {
    goto: function (index) {
      this.$router.push(this.routerLinks[index]);
    },
    isItemSelected: function (index) {
      var isItemSelected = '';
      for(var i = 0; i < this.routerLinks.length; i++){
        if(this.routerLinks[i] == this.$route.path.toLowerCase()){
          if(index == i%3) {
            isItemSelected = 'active';
          }
        }
      }
      return isItemSelected;
    },
  }
}
</script>

<style>
  .BottomNav {
    height: 52px;
  }
  .BottomNav-wrapper-line {
    height: 2px;
    background-color: #D8DBDE;
  }
  .BottomNav-line {
    top: 0;
    left: 0;
    width: 16%;
    background-color: #1EA5DE;
    transition: all 200ms ease-out;
  }
  .BottomNav-line.active0 {
    left: calc(25% - 10px - 8%);
  }
  .BottomNav-line.active1 {
    left: calc(50% - 8%);
  }
  .BottomNav-line.active2 {
    left: calc(75% - 8% + 10px);
  }
  .BottomNav-wrapper {
    height: 50px;
    background-color: #ffffff;
    padding-top: 7px;
  }
  .BottomNav-wrapper-side {
    width: calc(50% - 50px);
  }
 .BottomNav-wrapper-middle {
    width: 100px;
  }
  .BottomNav-svg {
    width: 20px;
    height: 20px;
    margin: auto;
  }
  .BottomNav-svg path {
    fill: #B7B9BC;
    transition: fill 100ms linear;
  }
  .BottomNav-wrapper-middle.active .BottomNav-svg path {
    fill: #000000;
  }
  .BottomNav-text {
    height: 23px;
    line-height: 23px;
    color: #B7B9BC;
    transition: all 100ms linear;
  }
  .BottomNav-wrapper-middle.active .BottomNav-text {
    color: #000000;
  }
  .BottomNav-circle {
    top: 17px;
    left: 50%;
    width: 0;
    height: 0;
    background-color: rgba(141, 197, 243, 0.6);
    border-radius: 50%;
    transition: all 200ms ease-out;
  }
  .BottomNav-wrapper-middle.active .BottomNav-circle {
    top: 10px;
    left: calc(50% - 7px);
    width: 14px;
    height: 14px;
    transition: all 200ms ease-in;
  }
</style>
